module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "video-static",
      "classes": ['v--modal', 'responsive-modal'],
      "width": _vm.modalWidth,
      "height": _vm.modalHeight,
      "adaptive": true
    }
  }, [_c('div', {
    staticClass: "video-static-container"
  }, [_c('div', {
    staticClass: "video-frame"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.modalSrc,
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      "referrerpolicy": "strict-origin-when-cross-origin",
      "allowfullscreen": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ef31a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoStaticModal.vue
// module id = 273
// module chunks = 0